import React, {Component} from "react";
import DataTable from "react-data-table-component";
import ApiConnect from "../../../Utils/ApiConnect";


class Members extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewData: [],
      loading: true,
      filterText: "",
    };
this.columns = [
      {
        name: "Full Name",
        selector: row => row.fullname,
        sortable: true,
      },
      {
        name: "Contact",
        selector: row => row.contact,
        sortable: true,
      },
      {
        name: "OTP",
        selector: row => row.otp,
        sortable: true,
      },
      {
        name: "Last Visit",
        selector: row => row.last_visit,
        sortable: true,
      },
      ];
  }
  componentDidMount() {
    this.GetMemberData();
  }

  customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };
  GetMemberData() {
    ApiConnect.get("Members/Information/UsersMemberlist")
      .then((response) => {
        if (response.data.status === 200) {
          this.setState({ viewData: response.data.data, loading: false });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  render() {
    const filteredData = this.state.viewData.filter(item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(this.state.filterText.toLowerCase())
      )
    );
    return (
      <div className="card">
        <div className="card-body">
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search..."
              onChange={e => this.setState({ filterText: e.target.value })}
            />
          </div>
          <DataTable
            className="table"
            keyField="id"
            columns={this.columns}
            data={filteredData}
            pagination
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
            paginationPerPage={10}
            customStyles={this.customStyles}
            filter
            exportable
            loading={this.state.loading}
          />
        </div>
      </div>
    );
  }
}

export default Members;
